import { render, staticRenderFns } from "./PrimaryBeneficiaries.vue?vue&type=template&id=110f4343&scoped=true"
import script from "./PrimaryBeneficiaries.vue?vue&type=script&lang=js"
export * from "./PrimaryBeneficiaries.vue?vue&type=script&lang=js"
import style0 from "./PrimaryBeneficiaries.vue?vue&type=style&index=0&id=110f4343&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110f4343",
  null
  
)

export default component.exports